import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ClarityModule } from 'clarity-angular';
import { AppComponent } from './app.component';
import { ROUTING } from "./app.routing";
import { HomeComponent } from "./home/home.component";
import { CategoryComponent } from './category/category.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { SettingsComponent } from './settings/settings.component';
import { QuibblComponent } from './quibbl/quibbl.component';
import { QuibblTreeComponent } from './category/quibbl-tree/quibbl-tree.component';
import { QuibblInspectorComponent } from './category/quibbl-inspector/quibbl-inspector.component';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AuthService } from './auth.service';
import { QuibblService } from './quibbl.service';
import { LoginComponent } from './login/login.component';
import { VoteToggleComponent } from './common/vote-toggle/vote-toggle.component';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { ReversePipe } from './pipes/reverse.pipe';
import { FirstSentencePipe } from './pipes/first-sentence.pipe';
import { ActivityComponent } from './common/activity/activity.component';
import { QuibblGridComponent } from './common/quibbl-grid/quibbl-grid.component';
import { QuibblCardComponent } from './common/quibbl-card/quibbl-card.component';
import { ToggleButtonComponent } from './common/toggle-button/toggle-button.component';
import { QuibblVotesComponent } from './category/quibbl-inspector/quibbl-votes/quibbl-votes.component';
import { QuibblDiscussionComponent } from './category/quibbl-inspector/quibbl-discussion/quibbl-discussion.component';
import { QuibblRelatedComponent } from './category/quibbl-inspector/quibbl-related/quibbl-related.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { ProfileComponent } from './profile/profile.component';
import { AdminComponent } from './admin/admin.component';
import { ReviewComponent } from './review/review.component';
import { Autosize } from './directives/autosize.directive';
import { InputBarComponent } from './common/input-bar/input-bar.component';
import { CommentsComponent } from './common/comments/comments.component';
import { TagComponent } from './common/tag/tag.component';
import { Angulartics2Module, Angulartics2GoogleAnalytics } from 'angulartics2';
import { KeysPipe } from './pipes/keys.pipe';
import { FooterComponent } from './common/footer/footer.component';
import { AboutComponent } from './about/about.component';
import { TermsComponent } from './terms/terms.component';
import { ContactComponent } from './contact/contact.component';
import { TodayComponent } from './today/today.component';
import { ChannelPanelComponent } from './leaderboard/channel-panel/channel-panel.component';
import { CapitalizeFirstPipe } from './pipes/capitalize-first.pipe';
import { SearchComponent } from './common/search/search.component';
import { TrophyComponent } from './common/trophy/trophy.component';
import { ShareButtonsModule } from 'ngx-sharebuttons';
import { environment } from '../environments/environment';
import { MarchMadnessComponent } from './march-madness/march-madness.component';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        CategoryComponent,
        LeaderboardComponent,
        SettingsComponent,
        QuibblComponent,
        QuibblTreeComponent,
        QuibblInspectorComponent,
        LoginComponent,
        VoteToggleComponent,
        TimeAgoPipe,
        ReversePipe,
        FirstSentencePipe,
        ActivityComponent,
        QuibblGridComponent,
        QuibblCardComponent,
        ToggleButtonComponent,
        QuibblVotesComponent,
        QuibblDiscussionComponent,
        QuibblRelatedComponent,
        TruncatePipe,
        ProfileComponent,
        AdminComponent,
        ReviewComponent,
        Autosize,
        InputBarComponent,
        CommentsComponent,
        TagComponent,
        KeysPipe,
        FooterComponent,
        AboutComponent,
        TermsComponent,
        ContactComponent,
        TodayComponent,
        ChannelPanelComponent,
        CapitalizeFirstPipe,
        SearchComponent,
        TrophyComponent,
        MarchMadnessComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpModule,
        ClarityModule.forRoot(),
        ROUTING,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        Angulartics2Module.forRoot([ Angulartics2GoogleAnalytics ]),
        ShareButtonsModule.forRoot()
    ],
    providers: [ AuthService, QuibblService ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/app.module.ts